export default __webpack_public_path__ + "static/media/mejapintarpage.f19599ce.png";